import { Card, CardContent } from '../../../ui/card'

const ErrorState = () => (
  <div className="p-6 max-w-4xl mx-auto">
    <Card className="bg-red-50">
      <CardContent className="p-6">
        <h2 className="text-xl font-semibold text-red-700 mb-2">Schedule not found</h2>
      </CardContent>
    </Card>
  </div>
);

export default ErrorState;